<p>Validating Authorization Tokens...</p>
<div>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
